class ProductFixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setVisibility()
  }

  setVisibility () {
    this.setAttribute('aria-hidden', !this.shouldBeVisible)
  }

  get shouldBeVisible () {
    if (!this.externalEls?.form?.exists) return

    const formFooter = this.externalEls.form.element
    const pageFooter = this.externalEls.footer.element

    const formFooterOffsetTop = formFooter.offsetTop
    const formFooterHeight = formFooter.offsetHeight
    const pageFooterOffsetTop = pageFooter.offsetTop
    const windowHeight = window.innerHeight

    if (
      this.lastKnownY > formFooterOffsetTop + formFooterHeight &&
      this.lastKnownY < pageFooterOffsetTop - windowHeight / 2
    ) {
      return true
    } else {
      return false
    }
  }
}

if (!customElements.get('product-fixed-bar')) {
  customElements.define('product-fixed-bar', ProductFixedBar)
}
